import axios from "axios";
import { AuthUtil } from "../utils/AuthUtil";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
export const fileDownloadBaseURL = process.env.REACT_APP_BASE_URL + "files/download/";

export const AxiosConfig = axios.create({
  headers: {
    "content-type": "application/json",
    //"accept": "application/json"
    // "Authorization": `Bearer ${AuthUtil.getAuthHeaderTocken()}`,
    // "Access-Control-Allow-Origin": "https://azureapiqa.masholdings.com"
    // "Accept": "application/json",
    // "Access-Control-Allow-Methods" : "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
});

//api.defaults.headers.common['Authorization'] = 'Auth From Api';


export const fileServiceConfig = axios.create({
  headers: {
    "content-type": "application/json",
    //headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data'
    //},
  },
});

fileServiceConfig.interceptors.request.use((request:any) => {
  request.headers["authorization"] = `Bearer ${AuthUtil.getAuthHeaderTocken()}`;
  console.log(request);
  return request;
});
fileServiceConfig.interceptors.response.use((response) => {
  console.log(response);
  return response;
});




